import React from 'react';
import ReactDOM from 'react-dom/client';

import AccommodationSearchCompact from './AccommodationSearchCompact';

const root = ReactDOM.createRoot(
  document.getElementById('accommodation_search_compact')
);

root.render(
  <React.StrictMode>
    <AccommodationSearchCompact />
  </React.StrictMode>
);
